export function numberToColonesFormat(number) {
  number = Number(number);
  number = Number(number.toFixed(2));
  return "₡ " + number.toLocaleString("es-CR");
}
